import { Registration } from '@stax-core/types-omni';

export const tsysDirectMapper = (r: Registration) => ({});
